import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "flyAnywhere/fetch";
    ActionTypes["fetchSuccess"] = "flyAnywhere/fetchSuccess";
    ActionTypes["fetchError"] = "flyAnywhere/fetchError";
    ActionTypes["reset"] = "flyAnywhere/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (data) => ({
        payload: { ...data }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
